import { parseISOString } from './parseISOString'

export const RETURN_DATE_NOT_DESCRIPTIVE = true

export function formatDateTimeStringDateOnly(
  value: string | null,
  returnDateNotDescriptive = false
) {
  if (value === null) {
    return value
  }

  if (!value) {
    return undefined
  }

  const d = new Date()
  const d1 = new Date()
  d1.setDate(d1.getDate() - 1)

  const valueDate = parseISOString(value).toLocaleDateString('sv')
  const today = d.toLocaleDateString('sv')
  const yesterday = d1.toLocaleDateString('sv')

  return valueDate === today && !returnDateNotDescriptive
    ? 'Today'
    : valueDate === yesterday && !returnDateNotDescriptive
    ? 'Yesterday'
    : valueDate
}
